import { Label, TextInput } from "flowbite-react";
import { useState } from "react";
import { FaEyeSlash, FaRegEye } from "react-icons/fa";

type Props = {
  id: string;
  label?: string;
  value?: string;
  placeholder?: string;
  autoComplete?: string;
  onChange: (valor: string) => void;
};

export default function InputSenha({
  id,
  label,
  value,
  placeholder,
  autoComplete,
  onChange,
}: Props) {
  const [visivel, setVisivel] = useState(false);

  return (
    <div>
      {label && (
        <div className="mb-2 block">
          <Label htmlFor={id} value={label} />
        </div>
      )}
      <div className="relative">
        <TextInput
          id={id}
          type={visivel ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required={true}
          className="w-full [&_input]:pr-11"
        />
        <button
          type="button"
          onClick={() => setVisivel(!visivel)}
          aria-label={visivel ? "Ocultar senha" : "Mostrar senha"}
          className="absolute inset-y-0 right-0 flex items-center px-3 text-lg text-myred"
        >
          {visivel ? <FaRegEye /> : <FaEyeSlash />}
        </button>
      </div>
    </div>
  );
}
